import React from 'react';

interface TypingIndicatorProps {
  isTyping: boolean;
  typingUsers?: string[];
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ isTyping, typingUsers = [] }) => {
  if (!isTyping) return null;

  const getTypingText = () => {
    if (typingUsers.length === 0) return 'Someone is typing...';
    if (typingUsers.length === 1) return `${typingUsers[0]} is typing...`;
    if (typingUsers.length === 2) return `${typingUsers[0]} and ${typingUsers[1]} are typing...`;
    return `${typingUsers[0]} and ${typingUsers.length - 1} others are typing...`;
  };

  return (
    <div className="flex items-center space-x-2 text-gray-500 text-sm animate-fadeIn py-2 px-4">
      <div className="flex space-x-1">
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
      </div>
      <span className="text-xs opacity-75">{getTypingText()}</span>
    </div>
  );
};

export default TypingIndicator;
